@use '~@cewe-designsystem-stylecomponents/mixins/breakpoints' as breakpoints;

/**
* @prop --cwc-modal-overlay-shadow: Dialog shadow, default `none`
*
* @prop --cwc-modal-overlay-min-width: Min width of the dialog, default `664px` via `$modal-text-width`
* @prop --cwc-modal-overlay-max-width: Max width of the dialog, default `664px` via `$modal-text-width`
*
* @prop --cwc-modal-overlay-min-height: Min height of the dialog, default `25dvh`
* @prop --cwc-modal-overlay-max-height: Max height of the dialog, default '75dvh'
*
* @prop --cwc-modal-backdrop-color: Backdrop color, default `rgba(0, 0, 0, 0.4)`
*
* @prop --cwc-modal-padding: Global padding, applied on all four sides and within header (half of global padding applied to bottom), body (half of global padding applied to top and bottom) and footer, default `2rem`
*
* @prop --cwc-modal-fullscreen-margin: Margin around modal in fullscreen mode, default `1rem`
*
* @prop --cwc-modal-border-radius: Modal border radius, default: `0`
*/

$modal-overlay-shadow: var(--cwc-modal-overlay-shadow, none) !default;

$modal-overlay-min-height: var(--cwc-modal-overlay-min-height, 25dvh) !default;
$modal-overlay-max-height: var(--cwc-modal-overlay-max-height, 75vh) !default;

$modal-backdrop-color: var(--cwc-modal-backdrop-color, rgba(0, 0, 0, 0.4)) !default;

// display at most approx. 80 characters, padding is later calculated on top
$modal-text-width: 664px !default;
$modal-text-width-mobile: 604px !default;

$modal-overlay-min-width: var(--cwc-modal-overlay-min-width, $modal-text-width) !default;
$modal-overlay-max-width: var(--cwc-modal-overlay-max-width, $modal-overlay-min-width) !default;

$modal-default-padding: 1rem !default;
$modal-padding: var(--cwc-modal-padding, $modal-default-padding) !default;

$modal-default-fullscreen-margin: 0 !default;
$modal-fullscreen-margin: var(--cwc-modal-fullscreen-margin, $modal-default-fullscreen-margin) !default;

$modal-border-radius: var(--cwc-modal-border-radius, 0) !default;

.cwc-modal:not([open]) ::slotted(*) {
  display: none;
}

.cwc-modal {
  flex-direction: column;
  min-height: $modal-overlay-min-height;
  max-height: $modal-overlay-max-height;
  padding: 0;
  overflow: hidden;
  transition:
    opacity 0.3s 50ms ease-in-out,
    transform 0.3s 50ms ease-in-out;
  border: 0 solid transparent;
  box-shadow: $modal-overlay-shadow;
  @starting-style {
    transform: scale(0.8);
    transform-origin: center;
    opacity: 0;
  }

  &:not(.cwc-modal--fullscreen) {
    border-radius: $modal-border-radius;
    @include breakpoints.breakpoint('md', 'up') {
      min-width: $modal-overlay-min-width;
      max-width: $modal-overlay-max-width;
    }
  }

  &[open] {
    display: flex;
  }
}

.cwc-modal--fullscreen {
  width: calc(100% - 2 * #{$modal-fullscreen-margin});
  min-width: initial;
  max-width: none;
  height: calc(100% - 2 * #{$modal-fullscreen-margin});
  min-height: initial;
  max-height: none;
  margin: $modal-fullscreen-margin;
}

.cwc-modal__close-button {
  display: flex;
  position: absolute;
  z-index: 1;
  top: 0;
  right: 0;
  align-items: center;
  justify-content: center;
  padding: 0.5rem;
  border: 0 solid transparent;
  background: transparent;
  cursor: pointer;
}

.cwc-modal__close-icon {
  width: 24px;
  height: 24px;
}

.cwc-modal__header {
  position: relative; // make box shadow work
  box-sizing: border-box;
  width: 100%;
  max-width: 100%;
  margin: 0 auto;

  // always keep space for close button on the right
  padding: $modal-padding 2rem calc(#{$modal-padding} / 2);

  box-shadow: 0 5px 5px #fff;

  text-align: center;

  &--text-left {
    padding-left: $modal-padding;
    text-align: left;
  }

  .cwc-modal--narrow & {
    width: $modal-text-width-mobile;
    @include breakpoints.breakpoint('sm', 'up') {
      width: $modal-text-width;
    }
  }
}

.cwc-modal__body {
  box-sizing: border-box;
  flex-grow: 1;
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
  padding: calc(#{$modal-padding} / 2) $modal-padding;
  overflow: auto;

  .cwc-modal--narrow & {
    width: $modal-text-width-mobile;
    @include breakpoints.breakpoint('sm', 'up') {
      width: $modal-text-width;
    }
  }
}

.cwc-modal__footer-wrapper {
  position: relative;
  width: 100%;
  max-width: 100%;
  box-shadow: 0 -5px 5px #fff;
}

.cwc-modal__footer {
  position: relative;
  box-sizing: border-box;
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
  padding: $modal-padding;

  .cwc-modal--narrow & {
    width: $modal-text-width-mobile;
    @include breakpoints.breakpoint('sm', 'up') {
      width: $modal-text-width;
    }
  }
}

.cwc-modal::backdrop {
  background-color: $modal-backdrop-color;
  backdrop-filter: blur(7px);
}
